module.exports = __webpack_public_path__ + "img/dangheart.cf47ac51.png";